import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './add-on-list-tooltip-module.css';
import { locale } from '../add-ons/table/locale';

const AddOnListTooltip = (props) => {
  const { listings, addOn } = props;

  const renderListingsList = () => {
    if (listings.length > 0) {
      const addOnListings = listings.map((listing) => {
        return <p key={listing.id} className={styles.paddingLeft}>{listing.title}</p>;
      });

      return (
        <div className={styles.toolTipText}>
          { addOnListings }
        </div>
      );
    }
    return null;
  };

  const applyDefaultCursor = () => {
    if (listings.length <= 0) {
      return `${styles.defaultCursor}`;
    }
    return null;
  };

  const applyUnderLine = () => {
    if (listings.length > 0) {
      return `${styles.underline}`;
    }
    return null;
  };

  const listingsCountText = () => {
    if (listings.length === 0) {
      return 'All';
    }
    return `${listings.length}`;
  };

  const selectedEventMessage = listings.length > 1
    ? locale.allOrSomeEventsAndTickets
    : locale.oneEventSelected;

  return (
    <div className={`${styles.toolTip} ${applyDefaultCursor()}`}>
      <span className={applyUnderLine()}>
        <FormattedMessage
          {...selectedEventMessage}
          values={{ currencyCode: addOn.currency, listingsCountText: listingsCountText() }}
        />
      </span>
      {listings.length > 0 && renderListingsList()}
    </div>
  );
};

export default AddOnListTooltip;
